<template>
  <section>
    <upload-document
      v-if="showUploadForm"
      :form-sub-title="formSubTitle"
      @upload-success="onUploadSuccess"
      @closed="showUploadForm = false"
    />
    <br>
    <p class="p-style">
      Step 2: Job Details
    </p>
    <div class="user-div">
      <p class="user-content">
        Location:- <font
          class="font-my-style"
        >
          {{ locationName.site_name }}
        </font>
      </p>
      <p class="user-content">
        Category:- <font
          v-if="userDetails.service_provider.contractor_category !== null"
          class="font-my-style"
        >
          {{ userDetails.service_provider.contractor_category.name }}
        </font>
        <font v-else>
          N/A
        </font>
      </p>
    </div>
    <div v-if="isContractorDocVerifyFailed">
      <p
        v-for="(item, i) in contractorDocVerificationStatus.expired_documents"
        :key="i"
        class="fail-message-style"
      >
        <font>
          <v-icon
            size="30"
            color="#C62828"
          >
            mdi-close-thick
          </v-icon>
          {{ item.document_type.name }} is expired, please upload the renewed file.
        </font>
      </p>
    </div>
    <p
      v-if="verificationFailed"
      class="fail-message-style"
    >
      <font>
        <v-icon
          size="30"
          color="#C62828"
        >
          mdi-close-thick
        </v-icon>
        {{ verificationFailedMessage }}
      </font>
    </p>
    <v-card
      class="card-style"
      color="#ECEFF1"
      :style="getBgStyle"
    >
      <v-btn
        color="#37474F"
        class="upload-btn"
        outlined
        small
        @click="openUploadForm()"
      >
        <v-icon left>
          mdi-cloud-upload
        </v-icon>
        Document
      </v-btn>
      <br>
      <br>
      <v-card-text class="justify-center">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-container fluid>
            <v-autocomplete
              v-model="selectedJobNumber"
              :items="allJobs"
              item-value="id"
              color="#000000"
              filled
              outlined
              dense
              class="purple-input"
              light
              :item-text="getJobDescription"
              :rules="[(v) => !!v || 'This field is required']"
              label="Select Job Number"
              prepend-icon="mdi-account-hard-hat"
              hint="Select your Job number from the available list for continuing the check-in process."
              persistent-hint
              @input="getSelectedJobDetails()"
            />
            <br>
            <div v-if="isJobSelected">
              <v-switch
                v-model="hrw"
                color="#FF3700"
                class="hrw-switch"
                light
                readonly
              >
                <template #label>
                  <span class="input__label">HRW (High Risk Work)</span>
                </template>
              </v-switch>
              <v-textarea
                v-model="jobDescription"
                dense
                filled
                color="#000000"
                light
                disabled
                outlined
                label="Job Description"
              />
            </div>
            <br>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="#37474F"
                @click="cancel()"
              >
                Cancel
              </v-btn>
              <v-btn
                color="#FF3700"
                @click="jobDetailsGathered()"
              >
                Next
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import UploadDocument from './UploadDocument.vue';
import Constants from 'src/constants';

export default {
  name: 'GatherJobDetails',
  components: {
    'centre-spinner': spinner,
    'upload-document': UploadDocument,
  },
  filters: {
    arrangePretty (val) {
      return val.join(', ');
    },
  },
  data: () => ({
    selectedJobNumber: '',
    hrw: false,
    jobDescription: '',
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
    showUploadForm: false,
    formSubTitle: '',
    hrwDescription: null,
    valid: false,
    verificationFailed: false,
    verificationFailedMessage: '',
    documentCategory: '',
    location: 'NSW Tafe',
  }),
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    userDetails () {
      return this.$store.getters.getUser;
    },
    locationName () {
      return this.$store.getters['swiftuser/getLocationName'];
    },
     allJobs () {
      return this.$store.getters['swiftuser/getAllJobs'];
    },
    selectedJobDetails () {
      return this.$store.getters['swiftuser/getSelectedJobDetails'];
    },
    isJobSelected () {
      if (this.selectedJobNumber !== '' && Object.keys(this.selectedJobDetails).length > 0) {
        return true;
      }
      return false;
    },
    contractorDocVerificationStatus () {
      return this.$store.getters['swiftuser/getContractorDocVerifyStatus'];
    },
    isContractorDocVerifyFailed () {
      if (Object.keys(this.contractorDocVerificationStatus).length > 0 && this.contractorDocVerificationStatus.verification_status === 'failed') {
        return true;
      }
      return false;
    },
  },
  async mounted () {
    await this.fetchAllJobs();
  },
  methods: {
    async fetchAllJobs () {
      this.loading = true;
      await this.$store.dispatch('swiftuser/fetchAllJobs', {
        params: {
          status: 'pending',
        },
      });
      this.loading = false;
    },
    async getSelectedJobDetails () {
      this.loading = true;
      const jobDetails = this.allJobs.find(
        job => job.id === this.selectedJobNumber,
      );
      await this.$store.dispatch('swiftuser/saveSelectedJobDetails', jobDetails).then(response => {
        this.hrw = jobDetails.high_risk;
        this.jobDescription = jobDetails.description;
      });
      this.loading = false;
    },
    getJobDescription (item) {
      return `${item.job_number} - ${item.description}`;
    },
    jobDetailsGathered () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please select the job number before proceeding to next step.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      this.$store.dispatch('swiftuser/clearContractorDocVerifyStatus');
      if (this.hrw === true) {
        this.$store.dispatch('swiftuser/verifyDocuments', {
          type: 'job',
        }).then(response => {
          this.loading = false;
          if (this.isContractorDocVerifyFailed === true) {
            this.openUploadForm();
            return;
          }
          this.$emit('job-details-stored');
        }).catch(error => {
          this.loading = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
          this.openUploadForm();
        });
        return;
      }
      setTimeout(() => {
        this.loading = false;
        this.$emit('job-details-stored');
      }, 2000);
    },
    openUploadForm () {
      this.formSubTitle = `${this.verificationFailedMessage} Please upload your document here.`;
      this.showUploadForm = true;
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
    onUploadSuccess () {
      this.showUploadForm = false;
      this.verificationFailed = false;
      this.verificationFailedMessage = '';
    },
  },
};
</script>
<style scoped>
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.user-content {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  margin-left: 10px;
  font-family:'Times New Roman', Times, serif;
}
.font-my-style {
  font-weight: bold;
  font-size: 16px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
  text-transform: capitalize;
}
.upload-btn {
  float: right;
  margin-right: 25px;
  margin-top: 20px;
  margin-bottom: -10px;
}
.hrw-switch {
  margin-top: -5px;
  margin-left: -1px;
}
.input__label {
   font-weight: bold;
  font-size: 16px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
}
.user-div {
  line-height:normal;
  border-left: 3px solid #FF3700;
  margin-left: 10px;
}
.fail-message-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
.user-card {
  border-left: 3px solid #546E7A !important;
  border-bottom: 3px solid #546E7A !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
